import React from 'react';
import { HighlightedInformationStyles as S } from './HighlightedInformation.styles';
const HighlightedInformation = (props) => {
    return (React.createElement(S.Container, { innerWidth: "reduced" },
        React.createElement(S.Inner, null,
            React.createElement(S.Heading, null, props.heading && props.heading),
            props.content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }))));
};
export default HighlightedInformation;
